module.exports = __webpack_public_path__ + "static/img/active2.c850cc52.png";